import styled, {css} from "styled-components"
import media from 'styled-media-query'

export type BoxProps = {
  lado?: boolean
  color?: string | boolean
  active?: boolean
}
export const Box = styled.div<BoxProps>`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 37rem;
    min-height: 25rem;
    background-color: ${theme.colors.altBg};
    padding: 3rem 1.5rem;
    border-radius: 65px 0 65px 65px;
    text-align: center;
    border: 1px solid ${theme.colors.altBorder};

    a {
      text-decoration: none;
    }

    ${media.lessThan('medium')`
      margin: 0 auto;
      min-height: 25rem;
    `}
  `}
`


export const BoxTitle = styled.div<BoxProps>`
  ${({theme, color }) => css`
    width: 100%;
    font-family: ${theme.font.family};
    font-weight: ${theme.font.ultra};
    font-size: ${theme.font.sizes.xxlarge};
    line-height: ${theme.font.sizes.xxlarge};
    letter-spacing: 0;
    color: ${color};
    text-transform: uppercase;
    text-align: center;
    margin: 0 0 20px;
  `}
`

export const BoxSubTitle = styled.div<BoxProps>`
  ${({theme, color}) => css`
    width: 100%;
    font-family: ${theme.font.family};
    font-weight: ${theme.font.ultra};
    font-size: ${theme.font.sizes.large};
    line-height: ${theme.font.sizes.xxlarge};
    letter-spacing: 0;
    color: ${color};
    text-transform: uppercase;
    text-align: center;
    margin: 0 0 30px 0;
  `}
`

export const BoxContent = styled.div<BoxProps>`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    font-family: ${theme.font.family};
    font-weight: ${theme.font.ultra};
    font-size: ${theme.font.sizes.medium};
    line-height: ${theme.font.sizes.xxlarge};
    letter-spacing: 0;
    color: ${theme.colors.white};
  `}
`

export const BoxList = styled.div<BoxProps>`
  ${({theme, active}) => css`
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      text-align: left;
      width: 97%;
      height: 38px;
      margin-bottom: 10px;

      & span {
        color: ${active ? theme.colors.white : '#838383'};
          font-size: ${theme.font.sizes.small};
          line-height: ${theme.font.sizes.xlarge};
      }

      & svg {
          min-width: 33px;
      }

      ${media.lessThan("medium")`
      & span {
         padding-top: 3px;
         line-height: 2.1rem;
      }
         
    `}
  `}
`

export const BoxButton = styled.div<BoxProps>`
  position: relative;
  bottom: -35px;

  ${media.lessThan("medium")`
      bottom: -4.5rem;
  `}
`
